import { useState } from 'react';

export function useCustomAlert() {
  const [alertConfig, setAlertConfig] = useState({
    show: false,
    title: '',
    message: '',
    type: 'error',
    confirmText: 'OK',
    cancelText: 'Batal',
    showCancel: false,
    onConfirm: null
  });

  const showAlert = ({ 
    title = 'Peringatan', 
    message, 
    type = 'error',
    confirmText = 'OK',
    cancelText = 'Batal',
    showCancel = false,
    onConfirm = null
  }) => {
    setAlertConfig({
      show: true,
      title,
      message,
      type,
      confirmText,
      cancelText,
      showCancel,
      onConfirm
    });
  };

  const hideAlert = () => {
    setAlertConfig(prev => ({ ...prev, show: false }));
  };

  return {
    alertConfig,
    showAlert,
    hideAlert
  };
}
